import { render } from "./NewLecturesCreationPage.vue?vue&type=template&id=2c5e026c&scoped=true"
import script from "./NewLecturesCreationPage.vue?vue&type=script&lang=js"
export * from "./NewLecturesCreationPage.vue?vue&type=script&lang=js"

import "./NewLecturesCreationPage.vue?vue&type=style&index=0&id=2c5e026c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5e026c"]])

export default __exports__